module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-01.f985b77a.png";